<template>
  <div class="value">
    <Image v-if="content.icon" class="value__icon" :source="content.icon" alt="" />
    <p class="value__name">{{ content.title }}</p>
    <p class="value__desc">{{ content.description }}</p>
  </div>
</template>

<script>
import Image from '@/components/global/Image.vue'

export default {
  name: 'ValueBlock',
  components: { Image },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
